<template>
  <div class="hero section-type-b bground-config-clean presentation">
    <div class="personal-container">
      <div class="row section-type-b pt-5">
        <div class="col-12 presentation-inner-padding-top2">
          <div>
            <h1 class="text-center text-light mb-24">Grupo Felix</h1>
            <h2 class="text-center text-light mb-64">
              Línea de autos seminuevos
            </h2>
          </div>
          <img
            src="@/assets/images/marcas/CADILLAC LOGO-01.png"
            class="d-block mx-auto mb-64"
            style="max-width: 125px"
            alt=""
          />
          <div
            class="row section-type-c car-search justify-content-center mb-64"
          >
            <div class="col-12 car-results">
              <div class="row no-gutters">
                <!--Aqui van los coches-->
                <CocheCard
                  v-bind:key="coche.idVehiculo"
                  v-for="coche in coches"
                  :id="coche.idVehiculo"
                  :urlBackgroundImage="coche.portada"
                  :carModel="coche.nombre"
                  :releaseYear="coche.nombre"
                  :initialPayment="coche.contado"
                  :monthlyCost="coche.mensualidad"
                  :colors="coche.colores"
                ></CocheCard>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CocheCard from "@/components/CocheCard";
export default {
  name: "AutosUsadosCadillac",
  components: {
    CocheCard,
  },
  data() {
    return {
      coches: [],
    };
  },
  mounted() {
    this.$http
      .get("/web/vehicles/seminuevos/?page=1&limit=1&marca=2", {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        this.coches = res.data.data.elementos;
      });
  },
};
</script>
